import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAction, loginConfirmedAction } from '../../store/actions/AuthActions';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Ensure REACT_APP_API_URL is an absolute URL. Without a scheme the browser
// treats it as a relative path and appends it to the UI origin, producing a
// broken URL like https://<ui-host>/<api-host>/auth/saml/login.
const getSamlLoginUrl = () => {
  let base = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
  if (base && !/^https?:\/\//i.test(base)) {
    base = `https://${base}`;
  }
  return `${base}/auth/saml/login`;
};

const DirectLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    if (userDetails?.token) {
      try {
        dispatch(loginConfirmedAction(userDetails));
        // Redirect to dashboard after restoring session
        navigate('/dashboard');
      } catch (err) {
        console.error('Failed to restore session', err);
        toast.error('Could not restore session. Please login again.');
        localStorage.removeItem('userDetails');
      }
    }
  }, [dispatch, navigate]);

  // Handle SAML token callback or redirect
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const expireIn = urlParams.get('expireIn');

    if (token && expireIn) {
      dispatch(loginAction(true, undefined, undefined, { token, expireIn }, navigate, true)).catch(
        (err) => {
          console.error('Login failed', err);
          toast.error('Login failed. Please try again.');
        }
      );
    } else if (token === 'AZ401') {
      toast.error("Invalid user or users don't have access", {
        position: 'top-right',
        autoClose: 2000,
      });
    } else if (userDetails?.token) {
      // If already logged in, restore session and redirect to dashboard
      try {
        dispatch(loginConfirmedAction(userDetails));
        navigate('/dashboard');
      } catch (err) {
        console.error('Failed to restore session', err);
        localStorage.removeItem('userDetails');
        // Fallback to SAML login if restore fails
        window.location.href = getSamlLoginUrl();
      }
    } else {
      try {
        window.location.href = getSamlLoginUrl();
      } catch (err) {
        console.error('Redirect failed', err);
        toast.error('Cannot redirect to login. Backend may be offline.');
      }
    }
  }, [dispatch, navigate]);

  return (
    <section className="vh-100" style={{ backgroundColor: '#508bfc' }}>
      <ToastContainer />
    </section>
  );
};

export default DirectLogin;
